/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_TestingInputs */

const en_byoa_testing = /** @type {(inputs: Byoa_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing…`)
};

const id_byoa_testing = /** @type {(inputs: Byoa_TestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menguji…`)
};

/**
* | output |
* | --- |
* | "Testing…" |
*
* @param {Byoa_TestingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_testing = /** @type {((inputs?: Byoa_TestingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_TestingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_testing(inputs)
	return en_byoa_testing(inputs)
});